import React, { useEffect, useState } from 'react';
import {
  Table, Thead, Tbody, Tr, Th, Td, Button,
  Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter,
  useDisclosure, Flex, IconButton,
  Box
} from '@chakra-ui/react';
import { AddIcon } from '@chakra-ui/icons';
import SolicitudFraccionamiento from '../Ventanas/SolicitudFraccionamiento';

const TablaSolicitudFraccionamiento: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [modo, setModo] = useState<'view' | 'edit' | 'new'>('view');
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL || "http://127.0.0.1:5000"}/api/obras/solicitud-fraccionamiento`)
      .then(res => res.json())
      .then(setData)
      .catch(console.error);
  }, []);

  const openModal = (item: any, tipo: 'view' | 'edit') => {
    setSelectedItem(item);
    setModo(tipo);
    onOpen();
  };

  const openNuevo = () => {
    setSelectedItem(null);
    setModo('new');
    onOpen();
  };

  return (
    <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white" p={4}>
    <Table variant="simple" size="sm">
      <Thead bg="#5b182b">
          <Tr>
            <Th color="white">ID</Th>
            <Th color="white">Tipo Solicitud</Th>
            <Th color="white">Tipo Desarrollo</Th>
            <Th color="white">Responsable</Th>
            <Th color="white">Dirección</Th>
            <Th color="white">Superficie</Th>
            <Th color="white">Lotes</Th>
            <Th color="white">Acciones</Th>
          </Tr>
        </Thead>
        <Tbody>
          {data.map((item) => (
            <Tr key={item.id}>
              <Td>{item.id}</Td>
              <Td>{item.tipoSolicitud}</Td>
              <Td>{item.tipoDesarrollo}</Td>
              <Td>{item.responsable}</Td>
              <Td>{item.direccion}</Td>
              <Td>{item.superficie}</Td>
              <Td>{item.numLotes}</Td>
              <Td>
                <Button size="xs" onClick={() => openModal(item, 'view')}>Ver</Button>{' '}
                <Button size="xs" onClick={() => openModal(item, 'edit')}>Editar</Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Flex mt={4} justify="center">
        <IconButton
          icon={<AddIcon />}
          aria-label="Agregar nuevo"
          colorScheme="green"
          borderRadius="full"
          size="lg"
          position="fixed"
          bottom="20px"
          right="20px"
           zIndex={10} 
          onClick={openNuevo}
        />
      </Flex>

      <Modal isOpen={isOpen} onClose={onClose} size="6xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            {modo === 'view' && 'Ver Solicitud Fraccionamiento'}
            {modo === 'edit' && 'Editar Solicitud Fraccionamiento'}
            {modo === 'new' && 'Nueva Solicitud Fraccionamiento'}
          </ModalHeader>
          <ModalBody>
            <SolicitudFraccionamiento
              modo={modo}
              data={selectedItem}
              onSubmit={() => {
                onClose();
                window.location.reload();
              }}
            />
          </ModalBody>
          <ModalFooter>
            <Button onClick={onClose}>Cerrar</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default TablaSolicitudFraccionamiento;